import classNames from 'classnames';
import { HTMLAttributes, MouseEvent } from 'react';
import Link from '@/components/shared/Link';
import SliderArrowSvg from '@/svg/arrow.svg?url';
import generatePagination from '@/utils/generatePagination';
import Button from '../Button';

type Props = HTMLAttributes<HTMLElement> & {
    /**
     * Кол-во страниц
     */
    totalPages: number;
    /**
     * текущая страница
     */
    activePage: number;

    onClickHandler?: (pageTrigger: number) => void;
};

const NewPagination = ({ totalPages, activePage, onClickHandler }: Props) => {
    const pagesToShow = generatePagination(totalPages, activePage);

    const clickHandler = (e: MouseEvent<HTMLButtonElement>, pageTrigger: number) => {
        e.preventDefault();
        onClickHandler?.(pageTrigger);
    };

    return (
        <div className="new-pagination text-default-medium">
            <Button
                geometryVariant="mustache"
                size="sm"
                className={classNames('new-pagination-ctrl new-pagination-ctrl--prev', {
                    'is-disabled': activePage === 1,
                })}
                aria-label="Предыдущая страница"
                onClick={(e: MouseEvent<HTMLButtonElement> & MouseEvent<HTMLAnchorElement>) =>
                    clickHandler(e, Math.max(1, activePage - 1))
                }
                disabled={activePage === 0}
            >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src={SliderArrowSvg} alt="" width={10} height={10} className="img-fluid" decoding="async" />
            </Button>
            {pagesToShow.map((item) =>
                item.ellipsis ? (
                    <Link
                        href="/"
                        key={item.targetPage}
                        className="new-pagination-link"
                        aria-label={`№ ${item.targetPage}`}
                        onClick={(e: MouseEvent<HTMLButtonElement> & MouseEvent<HTMLAnchorElement>) =>
                            clickHandler(e, item.targetPage)
                        }
                    >
                        ...
                    </Link>
                ) : (
                    <Link
                        href="/"
                        key={item.targetPage}
                        className={classNames('new-pagination-link', {
                            'new-pagination-link--active': item.targetPage == activePage,
                        })}
                        tabIndex={item.targetPage == activePage ? -1 : 0}
                        onClick={(e: MouseEvent<HTMLButtonElement> & MouseEvent<HTMLAnchorElement>) =>
                            clickHandler(e, item.targetPage)
                        }
                    >
                        {item.targetPage}
                    </Link>
                ),
            )}
            <Button
                geometryVariant="mustache"
                size="sm"
                className={classNames('new-pagination-ctrl new-pagination-ctrl--next', {
                    'is-disabled': activePage == totalPages,
                })}
                aria-label="Следующая страница"
                onClick={(e: MouseEvent<HTMLButtonElement> & MouseEvent<HTMLAnchorElement>) =>
                    clickHandler(e, Math.min(totalPages, activePage + 1))
                }
                disabled={activePage === totalPages}
            >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src={SliderArrowSvg} alt="" width={10} height={10} className="img-fluid" decoding="async" />
            </Button>
        </div>
    );
};

export default NewPagination;
